import { ITagData } from '@/models';
import { IItemTagService } from './item-tag.types';
import { AxiosInstance } from 'axios';

export class ItemTagService implements IItemTagService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/csi/tags/';
  }

  fetchTags(): Promise<ITagData[]> {
    return this.axios
      .get<ITagData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchTag(id: number): Promise<ITagData> {
    return this.axios
      .get<ITagData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createTag(data: ITagData): Promise<ITagData> {
    return this.axios
      .post<ITagData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateTag(data: ITagData): Promise<ITagData> {
    return this.axios
      .patch<ITagData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteTag(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }
}
